import React from "react";
import { SvgIcon } from "@progress/kendo-react-common";
import * as svgIcons from "@progress/kendo-svg-icons";
import { useJobSetupStore } from "@presentation/stores/JobSetupStore";

import { requiredFieldBorder, useRequiredFieldState } from "../jobRequirements";
import { RequiredFieldNote } from "./RequiredFieldIndicators";
import { useRightPanelTabIndex } from "./useRightPanelTabIndex";

export const FastaFileFormBlock: React.FC = () => {
  const fastaFiles = useJobSetupStore((state) => state.CreateJobState.fastaFiles || []);
  const setRightPanelTab = useJobSetupStore((state) => state.setRightPanelTab);
  const fastaTabIndex = useRightPanelTabIndex("fasta");
  const hasFiles = fastaFiles.length > 0;

  const requiredState = useRequiredFieldState("fastaFiles");

  return (
    <fieldset className="k-form-fieldset">
      <legend className="k-form-legend">
        <strong>Fasta</strong> <SvgIcon style={{ paddingBottom: "5px" }} icon={svgIcons.fileDataIcon} />
      </legend>

      <div style={{ marginBottom: "10px" }}>
        <div
          style={{
            border: requiredFieldBorder(requiredState),
            borderRadius: "3px",
            padding: "8px",
            minHeight: "32px",
            backgroundColor: "white",
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "4px",
            cursor: hasFiles ? "default" : "pointer",
          }}
          onClick={hasFiles ? undefined : () => setRightPanelTab(fastaTabIndex)}
          title={hasFiles ? undefined : "Click to switch to the Fasta tab"}
        >
          {hasFiles ? (
            fastaFiles.map((file) => (
              <span
                key={file.path}
                style={{
                  backgroundColor: "#e3f2fd",
                  border: "1px solid #2196f3",
                  borderRadius: "3px",
                  padding: "2px 8px",
                  fontSize: "12px",
                  color: "#1976d2",
                }}
              >
                {file.path.split("/").pop() ?? file.path}
              </span>
            ))
          ) : (
            <span style={{ fontStyle: "italic", fontSize: "13px", color: "#666" }}>
              No FASTA files selected — click here or switch to the <strong>Fasta</strong> tab on the right.
            </span>
          )}
        </div>
        <RequiredFieldNote state={requiredState}>Select at least one FASTA file to continue.</RequiredFieldNote>
      </div>
    </fieldset>
  );
};
